import { decomposeSeasonal } from './seasonalDecomposer';
/**
 * Project future seasonal demand using decomposition results.
 * Extrapolates trend and applies seasonal indices.
 */
export function projectSeasonal(skuId, historicalPeriods, periodsAhead = 12, seasonLength = 12, _confidenceLevel = 0.8) {
    const decomposition = decomposeSeasonal(skuId, historicalPeriods, seasonLength);
    const lastTrend = decomposition.trend[decomposition.trend.length - 1];
    const trendSlope = decomposition.trend.length >= 2
        ? lastTrend - decomposition.trend[decomposition.trend.length - 2]
        : 0;
    const residualStd = stdDev(decomposition.residual);
    const zScore = 1.28; // ~80% confidence interval
    const projections = [];
    let projectedAnnual = 0;
    for (let i = 0; i < periodsAhead; i++) {
        const trendValue = lastTrend + trendSlope * (i + 1);
        const seasonIdx = (historicalPeriods.length + i) % seasonLength;
        const seasonalFactor = decomposition.seasonal[seasonIdx];
        const projected = Math.max(0, trendValue * seasonalFactor);
        const margin = zScore * residualStd * seasonalFactor;
        projections.push({
            period: `M+${i + 1}`,
            projectedDemand: Math.round(projected),
            lowerBound: Math.round(Math.max(0, projected - margin)),
            upperBound: Math.round(projected + margin),
        });
        projectedAnnual += projected;
    }
    return {
        skuId,
        projections,
        projectedAnnual: Math.round(projectedAnnual),
        confidence: decomposition.seasonalStrength,
    };
}
function stdDev(values) {
    if (values.length < 2)
        return 0;
    const mean = values.reduce((a, b) => a + b, 0) / values.length;
    const variance = values.reduce((sum, v) => sum + (v - mean) ** 2, 0) / values.length;
    return Math.sqrt(variance);
}
//# sourceMappingURL=seasonalProjector.js.map